module.exports = __webpack_public_path__ + "static/media/shop_tolm.145e613a.png";